import type { ApiResponse, Location } from '@court-sync/shared';
import { publicApiGet } from './apiClient';

export interface PublicClubProfileClub {
  id: string;
  name: string;
  slug: string;
  logoUrl: string | null;
  primaryColor: string | null;
  secondaryColor: string | null;
  description: string | null;
  bannerUrl: string | null;
  address: string | null;
  phone: string | null;
  email: string | null;
  website: string | null;
  subdomain?: string | null;
  subdomainEnabled?: boolean;
}

export interface PublicClubProfile {
  club: PublicClubProfileClub;
  courtHireAvailable: boolean;
  membershipJoinAvailable: boolean;
  websiteEmbedEnabled: boolean;
}

export const publicClubService = {
  async getProfile(clubSlug: string): Promise<ApiResponse<PublicClubProfile>> {
    return publicApiGet<PublicClubProfile>(`/public/clubs/${encodeURIComponent(clubSlug)}`);
  },

  async getProfileBySubdomain(label: string): Promise<ApiResponse<PublicClubProfile>> {
    return publicApiGet<PublicClubProfile>(
      `/public/clubs/subdomain/${encodeURIComponent(label)}`
    );
  },

  async getLocations(clubSlug: string): Promise<ApiResponse<Location[]>> {
    return publicApiGet<Location[]>(
      `/public/clubs/${encodeURIComponent(clubSlug)}/locations`
    );
  },

  async checkSubdomainAvailability(
    label: string,
    excludeClubId?: string
  ): Promise<ApiResponse<{ available: boolean; label: string }>> {
    const params = excludeClubId ? `?excludeClubId=${encodeURIComponent(excludeClubId)}` : '';
    return publicApiGet<{ available: boolean; label: string }>(
      `/public/clubs/subdomain/${encodeURIComponent(label)}/check${params}`
    );
  },
};
